<template>
  <div class="home">
    <div class="head-title">代理商列表</div>
    <div class="">
      <div class="">
        <div class="tianjia">
          <el-button type="primary" icon="el-icon-plus" @click="onSubmit = true"
            >添加代理商</el-button
          >
          <el-cascader
            clearable
            style="min-width: auto; width: 24.0rem; margin-left: 24px"
            placeholder="请选择地区"
            :options="options"
            v-model="selectedOptionson"
            @change="handleChang"
          ></el-cascader>
          <div style="display: inline-block;">
            <el-input
              clearable
              style="min-width: auto; width: 24.0rem; margin: 0 2.0rem 0 24px"
              v-model="account"
              placeholder="账号查询"
              @change="headlgetAgentUser"
            >
            </el-input>
            <el-button type="primary" slot="append" @click="headlgetAgentUser"
              >查询</el-button
            >
          </div>
          <el-table
            :data="tableData.data"
            
            border
            style="width: 100%; margin-top: 2.0rem"
            row-key="id"
            :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
          >
            <el-table-column prop="account" label="账号" width="120"></el-table-column>
            <el-table-column
              prop="enterpriseName"
              show-overflow-tooltip
              label="企业名称"
            ></el-table-column>
            <el-table-column prop="phone" label="手机号" width="120"></el-table-column>
            <el-table-column prop="province" label="省"></el-table-column>
            <el-table-column prop="city" label="城市"></el-table-column>
            <el-table-column prop="phoneTwo" label="备用电话"></el-table-column>
            <el-table-column prop="discount_price" label="折扣">
              <template slot-scope="scope">
                {{ scope.row.discount_price }}折
              </template>
            </el-table-column>
            <el-table-column prop="enterprisePhoto" label="营业执照">
              <template slot-scope="scope">
                <el-image
                  style="width: 7.0rem; height: 7.0rem"
                  :src="`${scope.row.enterprisePhoto}`"
                  :preview-src-list="[scope.row.enterprisePhoto]"
                  fit="scale-down"
                ></el-image>
              </template>
            </el-table-column>

            <el-table-column prop="is_deny" label="登录状态" width="180">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.is_deny"
                  :active-value="1"
                  :inactive-value="2"
                  @change="toggleStatus(scope.row.is_deny, scope.row.id)"
                  active-text="开启"
                  inactive-text="禁用"
                >
                </el-switch>
              </template>
            </el-table-column>

            <el-table-column
              prop="addtime"
              label="时间"
              width="180"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="280">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="
                    (dialogVisible = true),
                      bj(scope.row.id, scope.row),
                      shoujihao(scope.row.phone),
                      beiyon(scope.row.phoneTwo)
                  "
                  size="mini"
                  >编辑
                </el-button>
                <el-button
                  type="text"
                  @click="(zhiyuan = true), fp(scope.row.id)"
                  size="mini"
                  >资源分配</el-button
                >
                <el-button
                  @click="(conceal = true), money(scope.row)"
                  type="text"
                  size="mini"
                  >分配金额</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="paging">
            <pagination
              :total="tableData.total"
              :page.sync="listQuery.page"
              :limit.sync="listQuery.limit"
              :page-sizes="[10,20,50,100]"
              @pagination="headlgetAgentUser"
            />
          </div>
        </div>
        <!-- 资源弹出层 -->
        <el-dialog title="资源分配" center :visible.sync="zhiyuan" width="70%">
          <!-- 用户 -->
          <el-table
            :data="yonghu"
            style="width: 100%"
            
            border
            @selection-change="handleSelectionChange"
          >
            <el-table-column type="selection" width="100%"></el-table-column>
            <el-table-column
              prop="account"
              label="账号"
              style="width: 30%"
            ></el-table-column>
            <el-table-column
              prop="account_name"
              label="企业名称"
              style="width: 20.0rem"
            ></el-table-column>
            <el-table-column
              prop="phone"
              label="手机号"
              style="width: 30%"
            ></el-table-column>
            <el-table-column
              prop="province"
              label="省"
              style="width: 20%"
            ></el-table-column>
            <el-table-column
              prop="city"
              label="城市"
              style="width: 20%"
            ></el-table-column>
          </el-table>
          <span slot="footer" class="dialog-footer">
            <el-button @click="zhiyuan = false">取 消</el-button>
            <el-button type="primary" @click="(zhiyuan = false), fenpei()"
              >确 定</el-button
            >
          </span>
        </el-dialog>

        <el-dialog
          title="修改代理商信息"
          :visible.sync="dialogVisible"
          width="30%"
        >
          <el-form ref="formMf" label-width="10.0rem">
            <el-form-item label="密码">
              <el-input
                clearable
                v-model="formMf.name"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号">
              <el-input clearable v-model="formMf.phone"></el-input>
            </el-form-item>
            <el-form-item label="备用手机号">
              <el-input clearable v-model="formMf.phoneTwo"></el-input>
            </el-form-item>
            <el-form-item label="折扣">
              <el-input
                clearable
                v-model="formMf.discount_price"
                style="width: 30%"
                type="number"
              ></el-input>
              <span style="font-size: 2.0rem"
                >&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;折</span
              >
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="vak()">确 定</el-button>
          </span>
        </el-dialog>

        <el-dialog title="添加代理商" center :visible.sync="onSubmit" width="30%" @close="addResetForm('addform')">
          <el-form :rules="rules" ref="addform" :model="form" label-width="12.0rem">
            <el-form-item label="账号" prop="account">
              <el-input clearable v-model="form.account"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input
                clearable
                v-model="form.password"
                show-password
              ></el-input>
            </el-form-item>
            <el-form-item required label="确认密码" prop="passwordadd">
              <el-input
                clearable
                v-model="form.passwordadd"
                show-password
                @blur="inputtel()"
              ></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone">
              <el-input clearable v-model="form.phone"></el-input>
            </el-form-item>
            <el-form-item required label="市区选择">
<!--              <el-cascader-->
<!--               clearable-->
<!--               placeholder="请选择地区"-->
<!--                :options="options"-->
<!--                v-model="value"-->
<!--              ></el-cascader>-->

              <el-select clearable v-model="value" placeholder="请选择">
                <el-option
                  v-for="item in options2"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备用电话">
              <el-input
                clearable
                v-model="form.phoneTwo"
                @blur="inputphoneTwo()"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业名称" prop="enterpriseName">
              <el-input clearable v-model="form.enterpriseName"></el-input>
            </el-form-item>
            <el-form-item label="营业执照">
              <el-upload
                class="upload-demo"
                :action="`${baseURL}/api/Alioss/uploadTotal?agenttoken=${username.agenttoken}`"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                multiple
                :limit="1"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :on-success="chenggong"
              >
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  只能上传jpg/png文件，且不超过500kb
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="折扣">
              <el-input
                clearable
                v-model="form.discount_price"
                style="width: 30%"
                type="number"
              ></el-input>
              <span style="font-size: 2.0rem"
                >&nbsp;&nbsp;&nbsp;/&nbsp;&nbsp;折</span
              >
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addCancle()">取 消</el-button>
            <el-button type="primary" @click="numoo('addform')">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog title="分配金额" center :visible.sync="conceal" width="30%"  @close="resetForm('form')">
          <el-form ref="form" :model="form" label-width="8.0rem">
            <el-form-item label="分配金额">
              <el-input
                clearable
                v-model="monerto"
                type="number"
                placeholder="请输入金额"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="addCancle()">取 消</el-button>
            <el-button type="primary" @click="(conceal = false), moneyto()"
              >确 定</el-button
            >
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
import axios from "axios";
import qs from "qs";
import Vue from "vue";
import md5 from "js-md5";
import { provinceAndCityData, CodeToText } from "element-china-area-data";

export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.form.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      //url拼接字符串
      url: "https://api.weijub.com/",
      //  获取代理商列表
      tableData: {
        total: 0,
        data: [],
      },
      username: [],
      // 弹出层配置
      onSubmit: false, //添加弹出层
      dialogVisible: false, //修改弹出层
      zhiyuan: false, //资源分配
      conceal: false,
      // hasChildren:true,//二级列表
      form: {
        account: "", //账号
        password: "", //密码
        passwordadd: "", //确认密码
        phone: "", //手机号
        province: "", //省
        city: "", //市
        phoneTwo: "", //备用电话
        enterpriseName: "", //企业名称
        enterprisePhoto: "", //营业执照
        level_id: "", //从代理商等级管理获取，
        discount_price: "4", //折扣
      },
      checked: true,
      //修改数据
      formMf: {
        name: "",
        phone: "",
        phoneTwo: "",
        id: "",
        discount_price: "",
      },
      // 地址
      hadd: provinceAndCityData,
      hahha: [],
      //搜索地址
      options: [],
      selectedOptions: [],
      selectedOptionson: [],
      //图片上传
      fileList: [],
      //代理商等级
      daili: [],
      //用户信息
      yonghu: [],
      //用户地址
      formfp: {
        province: "",
        city: "",
      },
      baseURL: this.axios.defaults.baseURL,
      // 用户id
      yhid: "",
      arr: [],
      tooken: "",
      title: {},
      czphone: "",
      somoney: {},
      monerto: "",
      options: [],
      value: "",
      rules: {
        enterpriseName: [
          { required: true, message: "企业名称不能为空", trigger: "blur" },
        ],
        img: [{ required: true, message: "请上传营业执照", trigger: "blur" }],
        level_id: [
          { required: true, message: "请选择代理等级", trigger: "blur" },
        ],
        // 金额校验
        moneyr: [{ required: true, message: "金额不能为空", trigger: "blur" }],
        //备用手机
        phoneTwo: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { min: 11, max: 30, message: "手机格式不正确", trigger: "blur" },
        ],
        //手机
        phone: [
          { required: true, message: "手机号不能为空", trigger: "blur" },
          { min: 11, max: 30, message: "手机格式不正确", trigger: "blur" },
        ],
        account: [
          { required: true, message: "账号不能为空", trigger: "blur" },
          {
            min: 1,
            max: 30,
            message: "长度在 1 到 30 个字符",
            trigger: "blur",
          },
        ],
        password: [
          { required: true, message: "密码不能为空", trigger: "blur" },
          {
            min: 6,
            max: 30,
            message: "长度在 6 到 30 个字符",
            trigger: "blur",
          },
        ],
        passwordadd: [{ validator: validatePass2, trigger: "blur" }],
      },
      listQuery: {
        page: 1,
        limit: 20,
      },
      account: "",
      options2: [],
    };
  },

  // 页面刷新就请求到数据渲染到页面中
  mounted() {
    // if (window.sessionStorage.getItem("title")) {
    //   let title = JSON.parse(window.sessionStorage.getItem("title"));
    //   this.title = title;
    //   var a = document.title;
    //   document.title = title[0].website + "-" + a;
    // }
    if (window.sessionStorage.getItem("userinfo")) {
      let userinfo = JSON.parse(window.sessionStorage.getItem("userinfo"));
      this.username = userinfo;
    }
    //  获取代理商列表
    this.headlgetAgentUser();
    // 代理等级

    this.headlgetLevelList();
    this.getCityList();
    this.options = provinceAndCityData;
  },
  components: {},
  methods: {
    getCityList() {
      this.axios
        .post(
          "/api/Area/getCityList",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            name: this.username.province,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          // this._formatArray(res.data.data);
          this.options2 = res.data.data;
        })
        .catch(function (err) {});
    },
    _formatArray(array) {
      for (let index = 0; index < array.length; index++) {
        const element = array[index];
        element.label = element.name;
        element.value = element.id;
        if (element.children) {
          this._formatArray(element.children);
        }
      }
    },
    toggleStatus(status, id) {
      this.axios
        .post(
          "/api/Agent/denyAgent",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            id,
            status,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            if (res.data.msg == "登录超时") {
              this.$router.push("/mine");
            }
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    moneyto() {
      this.axios
        .post(
          "/api/Agent/assignTotalMoney",
          qs.stringify({
            agent_id: this.username.id,
            agenttoken: this.username.agenttoken,
            two_agent_id: this.somoney.id,
            city: this.formfp.city,
            total_money: this.monerto,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            this.conceal = false
            this.$refs[form].resetFields()
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else {
            if (res.data.msg == "登录超时") {
              this.$router.push("/mine");
            }
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
    money(e) {
      this.somoney = e;
    },
    onSubmiton() {
      this.axios
        .post(
          "/api/agent/getAgentUserTwo",
          qs.stringify({
            agent_id: this.username.id,
            agenttoken: this.username.agenttoken,
            province: this.formfp.province,
            city: this.formfp.city,
            phone: this.czphone,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    handleCurrentChange(val) {
      this.axios
        .post(
          "/api/agent/getAgentUserTwo",
          qs.stringify({
            agent_id: this.username.id,
            agenttoken: this.username.agenttoken,
            page: val,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    //tooken验证
    // 输入框正则
    inputphoneTwo() {
      if (this.form.phone == this.form.phoneTwo) {
        Toast("手机与备用手机不能一致");
        return;
      }
    },
    inputtel() {
      if (this.passwordadd !== this.passworda) {
        this.$message.error("请与密码保持一致");
        return;
      }
    },
    handleSelectionChange(val) {
      let aa = [];
      val.forEach((item) => {
        aa.push(item.id);
      });
      this.arr = aa;
    },
    // 代理等级
    headlgetLevelList() {
      this.axios
        .post(
          "/api/level/getLevelList",
          qs.stringify({
            agenttoken: this.username.agenttoken,
            agent_id: this.username.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.daili = res.data.data;
        })
        .catch(function (err) {});
    },
    // 获取代理商数据
    headlgetAgentUser() {
      this.axios
        .post(
          "/api/agent/getAgentUserTwo",
          qs.stringify({
            agent_id: this.username.id,
            agenttoken: this.username.agenttoken,
            page: this.listQuery.page,
            number_page:this.listQuery.limit,
            province: this.formfp.province,
            city: this.formfp.city,
            account: this.account,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.tableData = res.data.data;
        })
        .catch(function (err) {});
    },
    //  通过点击事件触发监听事件
    // 分配用户确认按钮
    fenpei() {
      var a = this.arr.toString();

      this.axios
        .post(
          "/api/agent/agentAccount",
          qs.stringify({
            parent_id: this.username.id,
            agent_id: this.formMf.id,
            user_account_id: a,
            agenttoken: this.username.agenttoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          Toast(res.data.msg);
        })
        .catch(function (err) {});
    },
    // 分配通过地址来筛选用户
    fp(e) {
      this.formMf.id = e;
      // 通过地址来筛选地址getAgentAccounts
      this.axios
        .post(
          "/api/agent/nonePrive",
          qs.stringify({
            agent_id: this.username.id,
            agenttoken: this.username.agenttoken,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/mine");
          }
          this.yonghu = res.data.data;
        })
        .catch(function (err) {});
    },
    // 获取到当前选择用户的id
    choice(e) {
      this.yhid += e + ",";
    },
    //图片上传
    chenggong(response, file, fileList) {
      this.form.enterprisePhoto = file.response.data;
    },
    //图片删除后返回的信息
    handleRemove(file, fileList) {},
    //上传成功后点击返回的图片信息
    handlePreview(file) {},
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 编辑
    bj(e, l) {
      this.formMf.id = e; //获取当前的索引值
      this.formMf.discount_price = l.discount_price;
    },
    shoujihao(e) {
      this.formMf.phone = e;
    },
    beiyon(e) {
      this.formMf.phoneTwo = e;
    },
    // 修改代理商
    vak() {
      // 修改代理商等级
      if (this.formMf.name) {
        this.axios
          .post(
            "/api/agent/editAgent",
            qs.stringify({
              password: this.$md5(this.formMf.name),
              phone: this.formMf.phone,
              phoneTwo: this.formMf.phoneTwo,
              id: this.formMf.id,
              discount_price: this.formMf.discount_price,
              agenttoken: this.username.agenttoken,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/mine");
            }
            if (res.data.code == 1) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.dialogVisible = false;
              this.headlgetAgentUser();
            } else if (res.data.code == 0) {
              this.dialogVisible = true;
              this.$message.error(res.data.msg);
            }
          })
          .catch(function (err) {});
      } else {
        this.axios
          .post(
            "/api/agent/editAgent",
            qs.stringify({
              phone: this.formMf.phone,
              phoneTwo: this.formMf.phoneTwo,
              id: this.formMf.id,
              discount_price: this.formMf.discount_price,
              agenttoken: this.username.agenttoken,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.msg == "登录超时") {
              this.$router.push("/mine");
            }
            if (res.data.code == 1) {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
              this.dialogVisible = false;
              this.headlgetAgentUser();
            } else if (res.data.code == 0) {
              this.dialogVisible = true;
              this.$message.error(res.data.msg);
            }
          })
          .catch(function (err) {});
      }
    },
    //删除
    dele(e) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(
              "/api/agent/delAgent",
              qs.stringify({
                id: e,
                agenttoken: this.username.agenttoken,
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/mine");
              }
              Toast(res.data.msg);
              this.headlgetAgentUser();
            })
            .catch(function (err) {});
        })
        .catch(() => {
          Toast("取消删除");
        });
    },
    //添加代理商
    numoo(formName) {
      // console.log(this.form.enterprisePhoto);
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.axios
            .post(
              "/api/agent/addAgent",
              qs.stringify({
                parent_id: this.username.id,
                account: this.form.account, //账号
                password: this.$md5(this.form.password), //密码
                stringCode: this.form.password,
                phone: this.form.phone, //手机号
                province: this.username.province, //省
                city: this.value, //市区
                phoneTwo: this.form.phoneTwo, //备用电话
                enterpriseName: this.form.enterpriseName, //企业名称
                enterprisePhoto: this.form.enterprisePhoto, //营业执照
                agenttoken: this.username.agenttoken,
                discount_price: this.form.discount_price, //折扣
              }),
              {
                headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
                },
              }
            )
            .then((res) => {
              if (res.data.msg == "登录超时") {
                this.$router.push("/mine");
              }
              if (res.data.code == 1) {
                // 重置form表单
                this.$refs['addform'].resetFields()
                this.onSubmit = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.headlgetAgentUser();
              } else if (res.data.code == 0) {
                this.onSubmit = true;
                this.$message.error(res.data.msg);
              }
            })
            .catch(function (err) {});
        } else {
          return false;
        }
      });
    },
    // 省市区二级联动
    handleChange(value) {
      //赋值省
      this.form.province = CodeToText[value[0]];
      //赋值市
      this.form.city = CodeToText[value[1]];
    },
    // 省市筛选
    handleChang(value) {
      console.log("value", value);
      //赋值省
      this.formfp.province = CodeToText[value[0]];
      //赋值市
      this.formfp.city = CodeToText[value[1]];
      this.headlgetAgentUser();
    },
    //添加代理商点击取消
    addCancle() {
      this.onSubmit = false
      // 重置form表单
      this.form.phoneTwo=''
      this.$refs['addform'].resetFields()
    },
    // 添加代理商点击关闭时清空form表格的数据
    resetForm (form) {
      this.form.phoneTwo=''
      this.$refs[form].resetFields()
    }
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-table thead {
  color: #ffffff;
}
.home {
  padding: 2rem;
  border-radius: .8rem;
  box-shadow: .3rem .3rem 2rem 0 rgba(0, 0, 0, 0.1);
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  margin-top: 2.0rem;
  width: 100%;
  height: 90%;
  background-color: #ffffff;
  box-shadow: .0rem 1px 6px .0rem rgba(0, 0, 0, 0.2);
  padding: 1.0rem 31px;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  position: relative;
}

::v-deep .cell {
  color: none;
}
</style>


